export const isObjectLiteral = (value: any) => `${value}` === "[object Object]";
